(function () {
  // Open
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-ysa-chat-open]');
    if (!trigger) return;

    const dialog = document.getElementById(trigger.dataset.ysaChatOpen);
    if (!dialog) return;

    // Lazy-load iframe on first open
    const iframe = dialog.querySelector('.ysa-chat-dialog__iframe');
    if (iframe && iframe.src === 'about:blank' && iframe.dataset.src) {
      iframe.src = iframe.dataset.src;
    }

    dialog.showModal();
  });

  // Close via close button
  document.addEventListener('click', function (e) {
    const closeBtn = e.target.closest('[data-ysa-chat-close]');
    if (!closeBtn) return;

    closeBtn.closest('dialog')?.close();
  });

  // Close on backdrop click
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('ysa-chat-dialog')) {
      e.target.close();
    }
  });

  window.addEventListener('message', function (e) {
    if (e.origin !== 'https://app.youshouldask.ai' || e.data !== 'close_button') return;

    document.querySelectorAll('.ysa-chat-dialog__iframe').forEach(function (iframe) {
      if (iframe.contentWindow === e.source) {
        iframe.closest('dialog')?.close();
      }
    });
  });
})();